export const DISPLAY_TOAST = "DISPLAY_TOAST";

export const displayToast = (data) => ({
  type: DISPLAY_TOAST,
  data,
});
